import { render, staticRenderFns } from "./setting-userinfo.vue?vue&type=template&id=b4534aa0"
import script from "./setting-userinfo.vue?vue&type=script&lang=js"
export * from "./setting-userinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports